'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var getDescendantProp = exports.getDescendantProp = function getDescendantProp(obj, path) {
	return path.split('.').reduce(function (acc, part) {
		return acc && acc[part];
	}, obj);
};
var isNumeric = function isNumeric(num) {
	return !isNaN(num);
};

var operatorCheck = exports.operatorCheck = function operatorCheck(operator, value1, value2) {
	var parsedValue2 = isNumeric(value2) ? Number(value2) : value2;

	switch (operator) {
		case 'TRUE':
			if (value1) {
				return true;
			}
			break;
		case 'FALSE':
			if (!value1) {
				return true;
			}
			break;
		case 'EQUAL':
			if (value1 === parsedValue2) {
				return true;
			}
			break;
		case 'NOT_EQUAL':
			if (value1 !== parsedValue2) {
				return true;
			}
			break;
		case 'GREATER_THAN':
			if (value1 > parsedValue2) {
				return true;
			}
			break;
		case 'LESS_THAN':
			if (value1 < parsedValue2) {
				return true;
			}
			break;
		case 'GREATER_THAN_OR_EQUAL_TO':
			if (value1 >= parsedValue2) {
				return true;
			}
			break;
		case 'LESS_THAN_OR_EQUAL_TO':
			if (value1 <= parsedValue2) {
				return true;
			}
			break;
		case 'CONTAINS':
			if (value1.includes(parsedValue2)) {
				return true;
			}
			break;
		default:
	}

	return false;
};